<template>
  <div class="create-list-item" v-click-feedback="'deep-background'">
    <div class="row">
      <div class="col col-10 col-center" v-if="icon || svgIcon">
        <div class="icon">
          <img :src="getIcon" v-if="icon" />
          <svg-icon :type="getSvgIcon" :color="getSvgColor" v-if="svgIcon" />
        </div>
      </div>
      <div class="col" :class="{ 'col-90': icon, 'col-100': !icon }">
        <div class="content">
          <div class="row">
            <div class="col col-90 col-center">
              <div class="function">
                {{ content }}
              </div>
              <div class="description" v-if="description">
                {{ description }}
              </div>
            </div>
            <slot>
              <div class="col col-10 col-center arrow">
                <img :src="images.arrow" />
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
 */
import scenariosIcon1 from 'assets/images/refactor-main/scenarios/icon1.png';
import scenariosIcon2 from 'assets/images/refactor-main/scenarios/icon2.png';
import scenariosIcon3 from 'assets/images/refactor-main/scenarios/icon3.png';
import scenariosIcon4 from 'assets/images/refactor-main/scenarios/icon4.png';
import scenariosIcon5 from 'assets/images/refactor-main/scenarios/icon5.png';
import scenariosIcon6 from 'assets/images/refactor-main/scenarios/icon6.png';

import arrow from 'assets/images/common/arrow.png';

let iconMap = {
  EXPENSE: scenariosIcon1,
  DOCUMENT: scenariosIcon2,
  EXTEND_ICON1: scenariosIcon3,
  EXTEND_ICON2: scenariosIcon4,
  EXTEND_ICON3: scenariosIcon5,
  EXTEND_ICON4: scenariosIcon6,
};

let businessTypeSvgNameMap = {
  SALARY_PAYMENT: 'business-type-payment-slip',
  REQUEST: 'business-type-application',
  EXPENSE: 'business-type-expense',
  AP_REQUEST: 'business-type-public-application',
  AP_PAYMENT: 'business-type-public-pay',
  CONTRACT: 'business-type-contract',
  BUDGET_JOURNAL: 'business-type-budget-journal',
  VENDOR: 'business-type-supplier-application',
  ACCRUAL: 'business-type-advanced-bill',
  OTHER: 'business-type-other',
  CUSTOM_ONE: 'business-typ-custom-one',
  CUSTOM_TWO: 'business-typ-custom-two',
  CUSTOM_THREE: 'business-typ-custom-three',
  CUSTOM_FOUR: 'business-typ-custom-four',
  CASH: 'business-cash',
};

export default {
  name: 'create-list-item',
  mixins: [],
  props: {
    content: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
    svgIcon: {
      type: String,
      default: '',
    },
    svgColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      images: {
        scenariosIcon1,
        arrow,
      },
    };
  },
  computed: {
    getIcon() {
      return iconMap[this.icon] || iconMap['DOCUMENT'];
    },
    getSvgIcon() {
      return businessTypeSvgNameMap[this.svgIcon] || businessTypeSvgNameMap['EXPENSE'];
    },
    getSvgColor() {
      return this.svgColor || getComputedStyle(document.body).getPropertyValue('--theme-main');
    },
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';
.create-list-item {
  background: #f9f9f9;
  border-radius: 12px;
  margin: 0 32px 24px 32px;
  padding: 24px;

  .icon {
    width: 44px;
    height: 44px;
    img {
      width: 44px;
      height: 44px;
    }
  }
  .icon-radio {
    width: 56px;
    height: 56px;
    .avatar {
      width: 56px;
      height: 56px;
      font-size: px(28);
      display: inline-block;
      line-height: 56px;
      //text-align: center;
      background: #5595d5;
      color: #fff;
      border-radius: 50%;
      margin-right: 2vw;
    }
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
  }
  .content {
    //padding: px(34) 0;
    text-align: left;
    &.has-border {
      /*border-bottom: 2px solid #f1f1f1;;*/
    }
    .function {
      //font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
      color: #0a0f1e;
      word-break: break-word;
    }
    .description {
      //font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 32px;
      color: #505564;
      margin-top: 8px;
    }
    .extro {
      font-size: 28px;
      color: #959595;
      text-align: right;
    }
    .arrow {
      img {
        float: right;
        width: px(15);
        height: px(26);
      }
    }
  }
}
</style>
